<ng-container *ngIf="isAddAllowed">
    <div class="card shadow">
        <div class="card-body" [ngBusy]="{busy: isBusy, message: ''}">
            <form [formGroup]="memoFrm">
                <div class="d-flex flex-wrap justify-content-start row">
                    <div class="d-flex flex-column col-xl-4 col-md-6 col-sm-12">
                        <label class="col-form-label">Audit By <app-required-label></app-required-label></label>
                        <input #auditInput type="text" class="form-control form-control-sm text-uppercase" formControlName="auditBy" [ngClass]="{'is-invalid': isControlInvalid(f.auditBy)}" placeholder="Last and First Name" maxlength="60">
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'Audit By'" [control]="f.auditBy" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-3 col-sm-12" >
                        <label for="" class="col-form-label">Audit Type <app-required-label></app-required-label>
            </label>
                        <app-select id="auditType"  name="auditType" [isPopUp]="true" [options]="auditTypeList" formControlName="auditType" [isInvalid]="isControlInvalid(f.auditType)" [ngClass]="{'is-invalid':
                    isControlInvalid(f.auditType)}">
                        </app-select>
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'Audit Type'" [control]="f.auditType" class="invalid-feedback">
                        </app-error>
                    </div>
                    
                    <div class="d-flex flex-column col-xl-2 col-md-3 col-sm-12">
                        <label for="" class="col-form-label">Audit Date <app-required-label></app-required-label>
            </label>
                        <app-ui-calendar formControlName="auditDate" name="auditDate" [ngClass]="{'is-invalid': isControlInvalid(f.auditDate)}" [isInvalid]="isControlInvalid(f.auditDate)">
                        </app-ui-calendar>
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'Audit Date'" [control]="f.auditDate" class="invalid-feedback">
                        </app-error>
                        <div class="invalid-feedback" *ngIf="memoFrm?.errors">
                            <div *ngIf="memoFrm.errors?.value?.isDateMoreThan" class="error-msg">
                                <p-message severity="error">Audit Date cannot be earlier than Facility Created Date</p-message>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-3 col-sm-12">
                        <label for="" class="col-form-label">Audit Visible To</label>
                        <app-select [isMultiSelect]="true" [selectAllRequired]="true" [isPopUp]="true" [options]="profileList" formControlName="auditVisibleTo" [isInvalid]="isControlInvalid(f.auditVisibleTo)" [ngClass]="{'is-invalid':
                    isControlInvalid(f.auditVisibleTo)}">
                        </app-select>
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'Audit Visible To'" [control]="f.auditVisibleTo" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-3 col-sm-12">
                        <label for="" class="col-form-label">VFC Pin</label>
                        <app-select [options]="vfcList" [isPopUp]="true" formControlName="vfcPin" [isInvalid]="isControlInvalid(f.vfcPin)" [ngClass]="{'is-invalid':
                    isControlInvalid(f.vfcPin)}">
                        </app-select>
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'VFC Pin'" [control]="f.vfcPin" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-12">
                        <label for="" class="col-form-label">Comments <app-required-label></app-required-label></label>
                        <textarea class="form-control form-control-sm" formControlName="comments" [ngClass]="{'is-invalid': isControlInvalid(f.comments)}" maxlength="1000"></textarea>
                        <app-error [isSubmit]="isMemoSubmit" [caption]="'Comments'" class="invalid-feedback" [control]="f.comments">
                        </app-error>
                    </div>
                </div>
            </form>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-between flex-column flex-md-row">
                <div class="d-flex align-items-center">
                    <app-required-label></app-required-label> denotes mandatory fields
                </div>
                <div class="d-flex justify-content-end">
                    <button pRipple type="submit" class="btn btn-sm btn-primary" (click)="createMemo()" *ngIf="isAddAllowed">Create</button>
                    <button pRipple type="button" class="btn btn-sm btn-secondary" (click)="resetMemo()" *ngIf="isAddAllowed">Reset</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<div class="overflow-auto w-vw" *ngIf="noteList && noteList.length > 0">
        <app-ui-table [data]="noteList" [headers]="headers" [showExport]="false" [doNotScroll] = "true" [multiSelectData]="{data: profileList, optionLabel: 'descr',
    optionValue: 'columnValue'}" (rowEditEvent)="updateMemo($event)">
        </app-ui-table>
</div>
<p #memo>&nbsp;</p>